/**
 * @fileoverview Custom bundle utilities and functions.
 */

/**
 * Removes selected item from selectedItems object and selected bundle kit view
 * bar of the user. This also releseases the button of the product from
 * selection area.
 * @param {number} selectedProductId - Variant id of the selected item.
 * @param {string} selectedProductHandle - Product handle of the selected item.
 * @param {string} selectedSelectionAreaId - Identifier for selection area.
 * @param {number} selectedSelectionAreaTotal - Running count of the selected
 *   items within the selection area.
 * @param {number} selectedSelectionAreaRequirement - Required items for
 *   selection area.
 * @param {object} selectedItems - Object containing the selected items in each
 *   selection area which contains, product id, handle, and image.
 * @param {HTMLelement} element - Button of the item to be removed item within
 *   selection area.
 */
function removeSelectedItem(
  selectedProductId,
  selectedProductHandle,
  selectedSelectionAreaId,
  selectedSelectionAreaTotal,
  selectedSelectionAreaRequirement,
  selectedItems,
  element
) {
  if (selectedSelectionAreaTotal == selectedSelectionAreaRequirement) {
    changeSelectionAreaState(selectedSelectionAreaId, true);
    $('.custom-bundle-form').removeClass('Button--primary');
    $('.custom-bundle-form').addClass(
      'Button--secondary custom-bundle-form-disabled'
    );
  }

  delete selectedItems[selectedSelectionAreaId][selectedProductHandle];

  $('.custom-bundle-price.Price--compareAt').removeClass('visible');
  $('.custom-bundle-price.Price--compareAt').text('');

  // Updates the new price after deleting an item from the selected bundle.
  $('.custom-bundle-price.Price--highlight').text(
    formatPriceWithCurrencySymbol(totalPriceChecker(selectedItems))
  );

  // Removes item from the selected bundle kit view bar of the user.
  $('.remove-icon-container').each(function () {
    if (
      selectedProductId == $(this).attr('data-product-id') &&
      selectedSelectionAreaId == $(this).attr('data-selection-area-id')
    ) {
      var bundleItem = $(this).next();

      $(this).addClass('remove-icon-hidden');
      $(bundleItem).addClass('bundle-item-hidden');
      $(bundleItem).attr({ 'data-empty': 'true' });
      $(bundleItem).removeAttr('src');
    }
  });

  $(element).removeClass('Button--secondary');
  $(element).addClass('Button--primary');
  $(element).text('add');
}

/**
 * Changes all the button state (disabled or enabled) within a selection area.
 * @param {string} selectionAreaId - Id of selection area where product is from.
 * @param {boolean} enableAdd - Flag which determines whether to change state
 *   (disabled or not) of buttons in a selection area.
 */
function changeSelectionAreaState(selectionAreaId, enableAdd) {
  $('.custom-bundle-button').each(function () {
    var iSelectionArea = $(this).attr('data-selection-area-id');
    var iSelectionState = $(this).text().trim().toLowerCase();
    if (iSelectionArea == selectionAreaId && iSelectionState == 'add') {
      if (enableAdd) {
        $(this).removeAttr('disabled');
        $(this).removeClass('Button--secondary');
        $(this).addClass('Button--primary');
      } else {
        $(this).attr('disabled', 'disabled');
        $(this).removeClass('Button--primary');
        $(this).addClass('Button--secondary');
      }
    }
  });
}

/**
 * Converts data (Object containing objects) to array of line items.
 * @param {object} data - Object containing objects of selected items.
 * @returns - Array of objects with object properties of id and quantity.
 */
function convertToLineItem(data) {
  var productIds = [];
  for (var selectionArea in data) {
    for (var selectedProduct in data[selectionArea]) {
      productIds.push({
        id: data[selectionArea][selectedProduct].productId,
        quantity: 1,
      });
    }
  }
  return productIds;
}

/**
 * Sums up all prices from selected items.
 * @param {object} selectedItems - Selected items in custom bundle.
 * @param {boolean} discounted - Whether to return discounted or original price
 *   of selected items.
 * @returns {number} - Total amount of items added all together.
 */
function totalPriceChecker(selectedItems, discounted = false) {
  var total = 0;

  // Check for ongoing sitewide sales.
  var saleSettings = getSiteSettings().sale_settings;
  var dataDiscount = Number($('.custom-bundle-info').attr('data-bundle-discount'));

  // Only allow sitewide sale settings to override bundle discount but not for
  // sale by tag settings.
  if (saleSettings.sitewide.active && Number(saleSettings.key) > dataDiscount) {
    dataDiscount = Number(saleSettings.key);
  }

  var bundleDiscount = Number(dataDiscount) / 100;
  for (var selectionArea in selectedItems) {
    Object.keys(selectedItems[selectionArea]).forEach((selectedProduct) => {
      var productPrice =
        selectedItems[selectionArea][selectedProduct].productPrice;
      // Check if need to total discounted price or normal price.
      total += discounted
        ? Number(productPrice - productPrice * bundleDiscount)
        : Number(productPrice);
    });
  }

  total += discounted
    ? preSelectedItemChecker(true, dataDiscount)
    : preSelectedItemChecker();
  return total;
}

/**
 * Sums up all the prices for preselected items.
 * @param {boolean} discounted - Whether to return discounted or original total
 *   price of preselected items.
 * @returns {number} - Total amount of items added all together.
 */
function preSelectedItemChecker(discounted = false, dataDiscount = 0) {
  var total = 0;
  var bundleDiscount = Number(dataDiscount) / 100;

  // Get all prices from preselected items.
  $('.bundle-item.preselected-item').each(function (e) {
    var productPrice = Number($(this).attr('product-price'));

    // Check if need to total discounted price or normal price.
    total += discounted
      ? productPrice - productPrice * bundleDiscount
      : productPrice;
  });
  return total;
}

/**
 * Replaces bundle ids on the updated html cart response with the new bundle
 * bundle prices by going through the current cart and looking for all the
 * products that have the same bundle id.
 * @param {htmlElement} html - AJAX response from rerendered cart with updates.
 * @param {Object} _this33 - The current instance of the cart.
 * @return {html} - Updated html with bundle prices.
 */
async function displayBundlePrice(html, _this33) {
  let cartContents = await fetch(window.theme.localeRootUrl + '/cart.js')
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  // Get all bundles with their bundle id with their original prices and
  // new prices.
  let bundlesInCart = {};

  for (let lineItem of cartContents.items) {
    // Check for a custom bundle or a bundle item.
    let lineItemBundleId =
      lineItem.properties['_custom_bundle_id'] ||
      lineItem.properties['_bundle_id'];

    if (lineItemBundleId != undefined) {
      if (!(lineItemBundleId in bundlesInCart)) {
        // Initialize bundle object for storing information b
        bundlesInCart[lineItemBundleId] = {
          finalPrice: 0,
          originalPrice: 0,
          finalLinePrice: 0,
          originalLinePrice: 0,
          productKeys: [],
        };
      }

      // Check for sitewide sale.
      let saleSettings = getSiteSettings().sale_settings;
      let dataDiscount = lineItem.properties['_bundle_discount'];
      if (saleSettings.sitewide.active && Number(saleSettings.key) > Number(dataDiscount)) {
        dataDiscount = saleSettings.key;
      }

      // We could have retrieved the final price of the line item, but sometimes
      // when multiple quantities are added to cart. The final price changes.
      // These are only tested with line items with discounts.
      //
      // Example:
      // - With quantity 1: final price = 1499
      // - With quantity 2: final price = 1500
      let bundleDiscount = Number(dataDiscount) / 100;

      bundlesInCart[lineItemBundleId].finalPrice += Math.round(
        lineItem.original_price - lineItem.original_price * bundleDiscount
      );
      bundlesInCart[lineItemBundleId].originalPrice += Number(
        lineItem.original_price
      );
      bundlesInCart[lineItemBundleId].finalLinePrice +=
        lineItem.final_line_price;
      bundlesInCart[lineItemBundleId].originalLinePrice +=
        lineItem.original_line_price;
      bundlesInCart[lineItemBundleId].productKeys.push(lineItem.key);
    }
  }

  // Show prices of the bundles from rerendered AJAX html.
  html = html.replaceAll('Cart--initial', '');

  // Replace item count with new AJAX response item count.
  // let itemCountAttribute = html.match(/itemCount":\s\d+/g); // TODO: Old regex that broke the cart ON A LAUNCH DAY!!
  let itemCountAttribute = html.match(/&quot;itemCount&quot;:\s\d+/g);

  let newCount = itemCountAttribute[0].replaceAll(/[^\d]/g, '');
  _this33.itemCount = Number(newCount);

  // Replaces the html element string with custom bundle price and original
  // custom bundle price.
  for (let bundleId in bundlesInCart) {
    let bundle = bundlesInCart[bundleId];
    let bundleFinalPrice = formatPriceWithCurrencySymbol(bundle.finalPrice);
    let bundleOriginalPrice = formatPriceWithCurrencySymbol(
      bundle.originalPrice
    );
    let bundleLineLevelFinalPrice = formatPriceWithCurrencySymbol(
      bundle.originalLinePrice
    );
    let bundleLineLevelOriginalPrice = formatPriceWithCurrencySymbol(
      bundle.finalLinePrice
    );
    let bundleProductKeys = bundle.productKeys.join(',');

    // Acronym meanings:
    // - pf: product final price
    // - po: product original price
    // - lf: line level final price
    // - lo: line level original price
    html = html.replaceAll('pf-' + bundleId, bundleFinalPrice);
    html = html.replaceAll('po-' + bundleId, bundleOriginalPrice);
    html = html.replaceAll('lf-' + bundleId, bundleLineLevelFinalPrice);
    html = html.replaceAll('lo-' + bundleId, bundleLineLevelOriginalPrice);
    html = html.replaceAll(
      `data-bundle-${bundleId}`,
      `data-bundle="${bundleProductKeys}"`
    );
  }
  return html;
}
